<template>
  <DashboardHeader title="Admissions">
    <v-layout row wrap>
      <Loader></Loader>
      <v-flex md3 xs12>
        <v-timeline
          class="ml-0"
          v-for="(applicant ,i) in applicants"
          :key="i+Math.random()+Math.random()"
        >
          <v-timeline-item>
            <template v-slot:icon>
              <span style="color:white">{{i+1}}</span>
            </template>
            <span @click="getApplicant(i)">{{applicant.firstname}} {{applicant.lastname}}</span>
            <br />
            <span @click="getApplicant(i)">Applying For: {{applicant.gradeApplyingFor}}</span>
          </v-timeline-item>
        </v-timeline>
      </v-flex>
      <v-flex md8 xs12>
        <v-card v-if="applicant != null" :color="getThemeColor" style="color:white" elevation="12">
          <v-row>
            <span
              class="mx-10 my-2 h4"
              style="display:inline"
            >Applicant: {{applicant.firstname}} {{applicant.lastname}}</span>
            <v-spacer></v-spacer>
            <span class="mx-10 my-2">
              Grade Applying For: {{applicant.gradeApplyingFor}}
              <br />

              <v-btn text @click="gotoDecision()" dark small>Make Decision</v-btn>
            </span>
          </v-row>
          <v-tabs v-model="tab" centered>
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#tab-1">Applicant Bio</v-tab>
            <v-tab href="#tab-2">Previous School</v-tab>
            <v-tab href="#tab-3">Parent/Guardian Details</v-tab>
            <v-tab href="#tab-4">Learner Medical Information</v-tab>
            <v-tab href="#tab-5">Correspondence/Emergency Contact</v-tab>
            <v-tab href="#tab-6">Submitted Documents</v-tab>
            <v-tab href="#tab-7">Determine Application</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item value="tab-1">
              <v-container>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Names:</v-card-text>
                      <v-card-title>{{applicant.firstname}}</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-card class="mx-4 my-2" shaped>
                      <v-card-text>Surname:</v-card-text>
                      <v-card-title>{{applicant.lastname}}</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-card class="mx-4 my-2" shaped>
                      <v-card-text>Email</v-card-text>
                      <v-card-title>{{applicant.email}}</v-card-title>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-card class="mx-4 my-2" shaped>
                      <v-card-text>Place of Birth:</v-card-text>
                      <v-card-title>{{applicant.placeOfBirth}}</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-card class="mx-4 my-2" shaped>
                      <v-card-text>Date of Birth</v-card-text>
                      <v-card-title>{{applicant.dob}}</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-card class="mx-4 my-2" shaped>
                      <v-card-text>ID Number:</v-card-text>
                      <v-card-title>{{applicant.idNumber}}</v-card-title>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-card class="mx-4 my-2" shaped>
                      <v-card-text>Gender:</v-card-text>
                      <v-card-title>{{applicant.gender}}</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-card class="mx-4 my-2" shaped>
                      <v-card-text>Physical Address:</v-card-text>
                      <v-card-title>{{applicant.physicalAddress}}</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-card class="mx-4 my-2" shaped>
                      <v-card-text>Applicant Cell:</v-card-text>
                      <v-card-title>{{applicant.learnerCell}}</v-card-title>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item value="tab-2">
              <v-container>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Last School Attended:</v-card-text>
                      <v-card-title>{{applicant.lsName}}</v-card-title>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Year Applicant Left:</v-card-text>
                      <v-card-title>{{applicant.lsYear}}</v-card-title>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Last School Physical Address:</v-card-text>
                      <v-card-title>{{applicant.lsAddress}}</v-card-title>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab-item value="tab-3">
              <v-container>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Parent/Guardian First Names:</v-card-text>
                      <v-card-title>{{applicant.parentFirstname}}</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Parent/Guardian Surname:</v-card-text>
                      <v-card-title>{{applicant.parentLastname}}</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Parent/Guardian ID Number:</v-card-text>
                      <v-card-title>{{applicant.parentIdNumber}}</v-card-title>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Parent/Guardian Tel:</v-card-text>
                      <v-card-title>{{applicant.parentTel}}</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Parent/Guardian Place of Work:</v-card-text>
                      <v-card-title>{{applicant.parentPlaceOfWork}}</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Parent/Guardian Work Tel:</v-card-text>
                      <v-card-title>{{applicant.parentWorkTel}}</v-card-title>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Parent/Guardian Email:</v-card-text>
                      <v-card-title>{{applicant.parentEmail}}</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Parent/Guardian Residential Address:</v-card-text>
                      <v-card-title>{{applicant.parentPhysicalAddress}}</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Parent/Guardian Work Address:</v-card-text>
                      <v-card-title>{{applicant.parentWorkAddress}}</v-card-title>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab-item value="tab-4">
              <v-container>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Medical Aid Number:</v-card-text>
                      <v-card-title>{{applicant.medicalAidNumber}}</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Medical Aid Name:</v-card-text>
                      <v-card-title>{{applicant.medicalAidName}}</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Medical Aid Main Member:</v-card-text>
                      <v-card-title>{{applicant.medicalAidMM}}</v-card-title>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Doctor's Full Names:</v-card-text>
                      <v-card-title>{{applicant.doctorName}}</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Doctor's Work Address:</v-card-text>
                      <v-card-title>{{applicant.doctorWorkAddress}}</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Doctor's Work Tel:</v-card-text>
                      <v-card-title>{{applicant.doctorWorkTel}}</v-card-title>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="12">
                    <v-card class="mx-2 my-2" shaped>
                      <v-card-text>Medical Condition:</v-card-text>
                      <v-card-title>{{applicant.medicalCondition}}</v-card-title>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab-item value="tab-5">
              <v-container>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-card class="mx-4 my-2" shaped>
                      <v-card-text>Contact Person:</v-card-text>
                      <v-card-title>{{applicant.emergencyContactPerson}}</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-card class="mx-4 my-2" shaped>
                      <v-card-text>Contact Person Home Tel:</v-card-text>
                      <v-card-title>{{applicant.emergencyContactPersonHome}}</v-card-title>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-card class="mx-4 my-2" shaped>
                      <v-card-text>Contact Person Work Tel:</v-card-text>
                      <v-card-title>{{applicant.emergencyContactPersonWork}}</v-card-title>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="12">
                    <v-card class="mx-4 my-2" shaped>
                      <v-card-text>Contact Person Relationship:</v-card-text>
                      <v-card-title>{{applicant.emergencyContactPersonRelationship}}</v-card-title>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab-item value="tab-6">
              <v-card>
                <v-tabs v-model="pdfsModel" centered>
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab href="#pdf-0">Progress Report</v-tab>
                  <v-tab href="#pdf-1">Transfer Card</v-tab>
                  <v-tab href="#pdf-2">Learner ID</v-tab>
                  <v-tab href="#pdf-3">Parent ID</v-tab>
                  <v-tab href="#pdf-4">Proof of Payment</v-tab>
                  <v-tab href="#pdf-5">Proof of Residence</v-tab>
                </v-tabs>

                <v-tabs-items v-model="pdfsModel">
                  <v-tab-item value="pdf-0">
                    <v-card flat>
                      <v-row
                        v-if="iframeSource.progressReportPS == null || iframeSource.progressReportPS == ''"
                      >
                        <v-alert type="warning" class="mx-auto h5">No File Exist For The Selection</v-alert>
                      </v-row>
                      <v-card v-else class="mx-4 mt-4 mb-2" shaped elevation="12" outlined>
                        <iframe
                          :src="iframeSource.progressReportPS"
                          frameborder="0"
                          width="100%"
                          height="700"
                        ></iframe>
                      </v-card>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="pdf-1">
                    <v-card flat>
                      <v-row
                        v-if="iframeSource.transferCardPS == null || iframeSource.transferCardPS == ''"
                      >
                        <v-alert type="warning" class="mx-auto h5">No File Exist For The Selection</v-alert>
                      </v-row>
                      <v-card v-else class="mx-4 mt-4 mb-2" shaped elevation="12" outlined>
                        <iframe
                          :src="iframeSource.transferCardPS"
                          frameborder="0"
                          width="100%"
                          height="700"
                        ></iframe>
                      </v-card>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="pdf-2">
                    <v-card flat>
                      <v-row v-if="iframeSource.idDocStu == null || iframeSource.idDocStu == ''">
                        <v-alert type="warning" class="mx-auto h5">No File Exist For The Selection</v-alert>
                      </v-row>
                      <v-card v-else class="mx-4 mt-4 mb-2" shaped elevation="12" outlined>
                        <iframe
                          :src="iframeSource.idDocStu"
                          frameborder="0"
                          width="100%"
                          height="700"
                        ></iframe>
                      </v-card>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="pdf-3">
                    <v-card flat>
                      <v-row
                        v-if="iframeSource.idDocParent == null || iframeSource.idDocParent == ''"
                      >
                        <v-alert type="warning" class="mx-auto h5">No File Exist For The Selection</v-alert>
                      </v-row>
                      <v-card v-else class="mx-4 mt-4 mb-2" shaped elevation="12" outlined>
                        <iframe
                          :src="iframeSource.idDocParent"
                          frameborder="0"
                          width="100%"
                          height="700"
                        ></iframe>
                      </v-card>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="pdf-4">
                    <v-card flat>
                      <v-row
                        v-if="iframeSource.proofOfPayment == null || iframeSource.proofOfPayment == ''"
                      >
                        <v-alert type="warning" class="mx-auto h5">No File Exist For The Selection</v-alert>
                      </v-row>
                      <v-card v-else class="mx-4 mt-4 mb-2" shaped elevation="12" outlined>
                        <iframe
                          :src="iframeSource.proofOfPayment"
                          frameborder="0"
                          width="100%"
                          height="700"
                        ></iframe>
                      </v-card>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="pdf-5">
                    <v-card flat>
                      <v-row
                        v-if="iframeSource.proofOfResidence == null || iframeSource.proofOfResidence == ''"
                      >
                        <v-alert type="warning" class="mx-auto h5">No File Exist For The Selection</v-alert>
                      </v-row>
                      <v-card v-else class="mx-4 mt-4 mb-2" shaped elevation="12" outlined>
                        <iframe
                          :src="iframeSource.proofOfResidence"
                          frameborder="0"
                          width="100%"
                          height="700"
                        ></iframe>
                      </v-card>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-card>
            </v-tab-item>

            <v-tab-item value="tab-7">
              <v-row>
                <div class="mx-auto my-6">
                  <v-btn dark x-large color="red" @click="openUnSuccess()">Application Unsuccessful</v-btn>
                  <v-textarea
                    v-if="unsuccess"
                    class="mt-4"
                    label="Comment About Decision"
                    v-model="unSuccessfulModel"
                  ></v-textarea>
                  <v-btn
                    v-if="unsuccess"
                    dark
                    x-large
                    color="red"
                    @click="submitDecision('unsuccess')"
                  >Confirm Decision</v-btn>
                </div>
                <div class="mx-auto my-6">
                  <v-btn dark x-large color="green" @click="openSuccess()">Application Successful</v-btn>
                  <v-textarea
                    v-if="success"
                    class="mt-4"
                    label="Comment About Decision"
                    v-model="successfulModel"
                  ></v-textarea>
                  <v-btn
                    v-if="success"
                    dark
                    x-large
                    color="green"
                    @click="submitDecision('success')"
                  >Confirm Decision</v-btn>
                </div>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
  </DashboardHeader>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader.vue";
import Loader from "@/components/Loader.vue";
import axios from "@/plugins/axios";

export default {
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    }
  },
  mounted() {
    this.$store.commit("setLoader", true);
    axios
      .getData("/auth/get-applicants", this.getAccessToken)
      .then(applicants => {
        this.$store.commit("setLoader", false);
        this.applicants = applicants;
      });
  },
  components: { DashboardHeader, Loader },
  data: () => ({
    snackBar: false,
    snackText: "",
    iframeSource: "",
    applicants: [],
    applicant: null,
    applicantIndex: null,
    tab: null,
    pdfsModel: null,
    text: "Lorem ipsum",
    success: false,
    unsuccess: false,
    successfulModel: "Application met all requirements as stipulated",
    unSuccessfulModel:
      "Application did not meet one or more of the requirements stipulated"
  }),
  methods: {
    getApplicant(i) {
      this.applicant = this.applicants[i];
      this.applicantIndex = i;
      this.tab = "tab-1";
      this.getDocuments();
    },
    openSuccess() {
      this.success = !this.success;
      this.unsuccess = false;
    },
    openUnSuccess() {
      this.unsuccess = !this.unsuccess;
      this.success = false;
    },
    gotoDecision() {
      this.tab = "tab-7";
    },
    submitDecision(status) {
      let comment = "";
      if (status == "success") {
        comment = this.successfulModel;
      } else {
        comment = this.unSuccessfulModel;
      }

      axios
        .postDataWithToken(
          "/auth/submit-application-decision",
          { applicant: this.applicant, comment, status },
          this.getAccessToken
        )
        .then(response => {
          if (response == "successful") {
            this.applicants.splice(this.applicantIndex, 1);
          }
        });
    },
    getDocuments() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-application-docs",
          { id: this.applicant.id },
          this.getAccessToken
        )
        .then(docs => {
          this.$store.commit("setLoader", false);
          this.iframeSource = docs;
        });
    }
  }
};
</script>

<style>
</style>

